import React from 'react';
import { Route, Navigate } from 'react-router-dom';

const PrivateRoute = ({ element, ...rest }) => {
  const accessToken = localStorage.getItem('accessToken');

  return accessToken ? element : <Navigate to="/" />;
};

export default PrivateRoute;
